// extracted by mini-css-extract-plugin
export default {"container":"ProductManagement_container__rQPB0"};